import { render, staticRenderFns } from "./powerDialog.vue?vue&type=template&id=0ed33c1c&scoped=true&"
import script from "./powerDialog.vue?vue&type=script&lang=js&"
export * from "./powerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed33c1c",
  null
  
)

export default component.exports